import { render } from "./AboutPage.vue?vue&type=template&id=b15b4e52&scoped=true"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=b15b4e52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15b4e52"]])

export default __exports__